<script>
/**
 * 発注 搬入予約 編集/詳細
 */
import CarryingRequestDialog from "../requests/dialogs/_CarryingRequestDialog.vue";
import CustomImageViewer from "../../../components/CustomImageViewer.vue";
import {mapActions, mapState} from "vuex";

export default {
  name: "RequestCarryInDetail",
  components: {
    CustomImageViewer, CarryingRequestDialog
  },
  mixins: [],
  props: {
    /**
     * 発注ID
     */
    orderId: {
      type: Number,
      default: () => null
    },
    /**
     * 編集可否
     */
    canEdit: {
      type: Boolean,
      default: () => false,
    },
    /**
     * 呼び出し元種別
     * order: 発注
     * modal: ドライバースケジュール
     */
    callerType: {
      type: String,
      default: () => 'order'
    },
  },
  data() {
    return {
      panel: null,
      page: 1,
      totalVisible: 7,
      enableCarryingRequestDialog: false,
      tableHeaders: [
        { value: 'manifest_no', text: 'マニフェスト番号' },
        { value: 'collected_date', text: '回収日' },
        { value: 'emission', text: '排出事業者' },
        { value: 'emission_location', text: '排出事業場' },
        { value: 'item_name', text: '品目' },
        { value: 'registration_completion_date', text: '登録完了日' },
        { value: 'intermediate_disposal', text: '中間処分' },
        { value: 'final_disposal', text: '最終処分' },
      ],
      order: null,
      manifests: [],
      searchCondition: {},
    }
  },
  computed: {
    ...mapState('DriverManifestRequestsCarryIn', {
      pagination: 'pagination'
    }),
  },
  watch: {
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.searchOrderRequestsCarryIn()
  },
  methods: {
    ...mapActions('DriverOrderRequestsCarryIn', {
      fetchOrderRequestCarryIn: 'show'
    }),
    ...mapActions('DriverManifestRequestsCarryIn', {
      fetchManifestRequestCarryIn: 'show',
    }),
    searchOrderRequestsCarryIn() {
      this.fetchOrderRequestCarryIn({id: this.orderId}).then((content) => {
        this.order = content
        // ダイアログで使用されるオーダー情報
        // オーダーID（編集時のみ）
        this.searchCondition.order_id = this.order.id
        // オーダー搬入ID（編集時のみ）
        this.searchCondition.order_carryin_id = this.order.order_carryin_id
        // 搬入日
        this.searchCondition.carryin_plan_date = this.order.carrying_date
        // 予定開始時間
        this.searchCondition.carryin_plan_time = this.order.carrying_time
        // 予定終了時間
        this.searchCondition.carryin_plan_end_time = this.order.carrying_end_time
        // 運搬担当者ID
        this.searchCondition.transport_user_id = this.order.transport_user_id
        // 運搬担当者名
        this.searchCondition.transport_user_name = this.order.transport_user_name
        // 運搬方法ID
        this.searchCondition.transportation_id = this.order.transportation_id
        // 車両番号
        this.searchCondition.vehicle_number = this.order.vehicle_number
        // 運搬先事業者ID
        this.searchCondition.trader_id = this.order.trader.id
        // 運搬先事業者名
        this.searchCondition.trader_name = this.order.trader.name
        // 運搬先事業場コード
        this.searchCondition.to_trader_location_code = this.order.trader.location.code
        // 運搬先事業場名
        this.searchCondition.to_trader_location_name = this.order.trader.location.name
        // 事業場（積替保管場所）
        this.searchCondition.trader_location_code = this.order.transport.location.code
        // 事業場名（積替保管場所）
        this.searchCondition.trader_location_name = this.order.transport.location.name
      })
      this.fetchManifestRequestCarryIn({id: this.orderId, page: this.page}).then((content) => {
        this.manifests = content.manifests
      })
    },
    /**
     * ページ チェンジイベント
     */
    pageChangeEvent () {
      this.searchOrderRequestsCarryIn()
    },
    /**
     * 搬入予約 ボタン クリックイベント
     */
    callCarryingRequestDialog () {
      this.enableCarryingRequestDialog = true
    },
    /**
     * 搬入予約 登録ボタンコールバック
     */
    carryingRequestRegisterCallback () {
      this.carryingRequestCancelCallback()
      this.searchOrderRequestsCarryIn()
    },
    /**
     * 搬入予約 キャンセルボタンコールバック
     */
    carryingRequestCancelCallback () {
      this.enableCarryingRequestDialog = false
    },
    closeButtonClickEvent () {
      this.previousControl()
    },
    /**
     * 戻る処理
     */
    previousControl () {
      if (this.$route.query.d !== undefined) {
        this.$router.push( { name: 'DriverDashboard' } )
      } else {
        this.$router.push( { name: 'DriverOrderRequests' } )
      }
    },
  }
}
</script>

<template>
  <v-container
    v-if="order"
    fluid>

    <v-row v-if="order.status && order.rejection_reason">
      <v-col>
        <v-alert
          prominent
          type="error"
        >
          <v-row align="center">
            <v-col class="grow">
              {{ order.rejection_reason }}
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>

    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">

            <h4
              v-if="order.request_no"
            >
              引取搬入番号: {{ order.request_no }}
            </h4>
            <h4
              v-if="order.carrying_date"
            >
              搬入日: {{ order.carrying_date | date_format }}&nbsp;{{ order.carrying_time | from_to_linked_time(order.carrying_end_time, ' 〜 ') }}
            </h4>
            <h4
              v-if="order.transport.location.code"
            >
              運搬担当者: {{ order.transport_user_name }}
              <span>&nbsp;&nbsp;&nbsp;&nbsp;運搬方法: {{ order.transportation_name }}</span>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;車両番号: {{ order.vehicle_number }}</span>
            </h4>
          </v-col>
        </v-row>
        <!-- 運搬先 -->
        <v-row>
          <v-col v-if="order.trader">
            <h4>運搬先事業者</h4>
            <ul style="list-style: none">
              <li>{{ order.trader.name }}</li>
              <li v-if="order.trader.address">
                <span v-if="order.trader.zip_code">〒{{ order.trader.zip_code }}&nbsp;</span>
                {{ order.trader.address }}
              </li>
              <li v-if="order.trader.phone_number">
                電話番号: {{ order.trader.phone_number }}
              </li>
            </ul>
          </v-col>
          <v-col>
            <h4>運搬先事業場</h4>
            <ul style="list-style: none">
              <li>{{ order.trader.location.name }}</li>
              <li v-if="order.trader.location.address">
                <span v-if="order.trader.location.zip_code">〒{{ order.trader.location.zip_code }}&nbsp;</span>
                {{ order.trader.location.address }}
              </li>
              <li v-if="order.trader.location.phone_number">
                電話番号: {{ order.trader.location.phone_number }}
              </li>
            </ul>
          </v-col>
        </v-row>
        <!-- /運搬先 -->
      </v-card-text>

      <!-- 報告写真 -->
      <custom-image-viewer :photos="order.photos" />
      <!-- /報告写真 -->

      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="canEdit"
          color="primary"
          class="text-h6"
          dark
          x-large
          @click="callCarryingRequestDialog"
        >
          搬入予約編集
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="manifests"
          :items-per-page="-1"
          dense
          disable-sort
          hide-default-footer
        >
          <template v-slot:[`item.collected_date`]="{item}">
            {{ item.collected_date | date_format }}
          </template>
          <template v-slot:[`item.emission`]="{item}">
            <div v-if="item.emission">
              {{ item.emission.name }}
              <v-tooltip
                top
                :open-on-hover="false"
              >
                <template #activator="{ on }">
                  <v-btn
                    v-if="item.emission.address"
                    icon
                    small
                    retain-focus-on-click
                    @click="on.click"
                    @blur="on.blur"
                  >
                    <v-icon small>
                      mdi-map-marker-outline
                    </v-icon>
                  </v-btn>
                </template>
                <small
                  v-if="item.emission.address"
                >
                  {{ item.emission.address }}
                </small>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:[`item.emission_location`]="{ item }">
            <div v-if="item.emission_location">
              {{ item.emission_location.name }}
              <v-tooltip
                top
                :open-on-hover="false"
              >
                <template #activator="{ on }">
                  <v-btn
                    v-if="item.emission_location.address"
                    icon
                    small
                    retain-focus-on-click
                    @click="on.click"
                    @blur="on.blur"
                  >
                    <v-icon small>
                      mdi-map-marker-outline
                    </v-icon>
                  </v-btn>
                </template>
                <small
                  v-if="item.emission_location.address"
                >
                  {{ item.emission_location.address }}
                </small>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:[`item.registration_completion_date`]="{item}">
            {{ item.registration_completion_date | unix_datetime_format }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-simple-table
              dense
            >
              <template v-slot:default>
                <tbody>
                <tr>
                  <th>マニフェスト件数</th>
                  <td class="text-right">
                    {{ order.manifest_count }}&nbsp;件
                  </td>
                </tr>
                <tr>
                  <th>合計数量</th>
                  <td class="text-right">
                    {{ order.total_carryin_amount }}
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="pagination.total_pages"
              :total-visible="totalVisible"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              @input="pageChangeEvent"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="callerType !== 'modal'">
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
        >
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
    <carrying-request-dialog
      :enable-dialog="enableCarryingRequestDialog"
      :conditions="searchCondition"
      @registerCallback="carryingRequestRegisterCallback"
      @cancelCallback="carryingRequestCancelCallback"
    />
  </v-container>
</template>

<style lang="scss">
.v-input--reverse .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;
  .v-application--is-ltr & {
    .v-input--selection-controls__input {
      margin-right: 0;
      margin-left: 8px;
    }
  }
  .v-application--is-rtl & {
    .v-input--selection-controls__input {
      margin-left: 0;
      margin-right: 8px;
    }
  }
}
</style>
<style scoped lang="scss">

.status-card {
  & .image-col {
    padding-top: 0;padding-bottom: 0;
    display: inline-flex;
  }
  & .status-col {
    padding-left: 0;padding-right: 0;
  }
}

.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
      &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}

.v-tooltip__content {
  opacity: 1!important;
  background-color: #ffffff !important;
  border: 1px solid #dddddd !important;
  color: #565656 !important;
}

</style>
